export function currencyFormatter(num) {
  return num.toLocaleString('en-US', {
    style: 'currency', currency: 'USD',
  })
}

export function pluralize(text, count, suffix = 's') {
  return count > 1 || count === 0 ? `${count} ${text}${suffix}` : `${count} ${text}`;
}

export function dbDateFormat(dateString) {
  return new Date(Date.parse(dateString)).toISOString()
}

export function getOptionName(name) {
  const parts = name.split('- ')

  if (parts.length < 2) return parts[0].split(' ')

  return parts[1].split(' ')
}

export function getOptionPrice(option, schoolId) {
  const priceForSchool = option.prices.find((price) => (price.schoolId || '').toString() === schoolId.toString());

  if (priceForSchool) return priceForSchool;

  return option.prices.find((price) => price.schoolId === null);
}

export function isDaylightSavingTime() {
  var today = new Date();
  var januaryOffset = new Date(today.getFullYear(), 0, 1).getTimezoneOffset();
  var currentOffset = today.getTimezoneOffset();

  if (januaryOffset !== currentOffset) {
    return true; // DST is currently in effect
  }

  return false; // DST is not currently in effect
}

function stdTimezoneOffset() {
  const jan = new Date(new Date().getFullYear(), 0, 1)
  const jul = new Date(new Date().getFullYear(), 6, 1)

  return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset())
}

export function isDSTObserved() {
  return new Date().getTimezoneOffset() < stdTimezoneOffset()
}

export function pstOrPdt() {
  if (isDSTObserved) return 'PDT'

  return 'PST'
}

export function getRandomInt(max = 10_000) {
  return Math.floor(Math.random() * max)
}

export function studentFullName(student, surname = false) {
  if (surname) return `${student.lastName}, ${student.firstName}`

  return `${student.firstName} ${student.lastName}`
}

export function isEmailValid(email) {
  return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email.toLowerCase())
}

export function formattedSeason(season) {
  const letters = season.replace(/\d/g, '');
  let numbers = parseInt(season.replace(/\D/g, '') || 0, 10);
  const capitalizedLetters = `${letters.charAt(0).toUpperCase()}${letters.slice(1)}`;

  if (capitalizedLetters.includes('Fall')) numbers -= 1;

  return `${capitalizedLetters} ${numbers}`;
}

export function seasonYear(season) {
  return parseInt((season.replace(/\D/g, '') || '0').toString(), 10);
}

export function orderPackageSubtotal(orderPackage) {
  const isFree = orderPackage.price === 0;
  let hasSummedPoseForAll = false;

  const addonsSum = orderPackage.addonSheets.reduce((acc, cur) => {
    if (hasSummedPoseForAll && cur.addon.id.toString() === '13') return acc + 0;
    if (cur.addon.id.toString() === '13') hasSummedPoseForAll = true;
    if (isFree && cur.addon.priceWithout) return acc + cur.addon.priceWithout;

    return acc + cur.addon.priceWith;
  }, 0);

  const extrasSum = orderPackage.orderPackageExtras.reduce((acc, cur) => {
    const price = cur.extra.prices[0];

    return acc + (isFree && price.priceWithout ? price.priceWithout : price.price);
  }, 0);

  return orderPackage.price + addonsSum + extrasSum + ((orderPackage.extraPoses || 0) * 25);
}
